import { DatePipe } from "@angular/common";
import { AbstractController } from "./abstract-controller";
export class FormatController extends AbstractController {

  
  /**
   * Return present time day
   * 
   * @returns Date
   */
  today() {
    return new Date().getTime()
  }


  /**
   * Format date hours according to the borne variable (fin or debut)
   * 
   * @param timestamp 
   * @param borne 
   * @returns Date
   */
  formatTimeStamp(timestamp: number, borne: string) {
    let date = new Date(timestamp);
    if (borne == 'debut') {
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
    }
    if (borne == 'fin') {
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      date.setMilliseconds(999);
    }
    return date;
  }

  /**
   * Take 2 dates (format timestamp) in parameter and return a sentence which describe the period between there 2 dates
   * 
   * @param debut 
   * @param fin 
   * @returns string
   */
  formatDate(debut: number, fin: number): string {
    const dateDebut = this.formatTimeStamp(debut, 'debut');
    let dateFin = fin >= this.today() ? this.formatTimeStamp(fin, 'fin') : this.formatTimeStamp(this.today(), 'fin');
    const difference = dateFin.getTime() - dateDebut.getTime();

    const { unit, value } = this.calculateTimeUnit(difference);

    return this.getFormattedDate(value, unit);
  }

  private calculateTimeUnit(difference: number): { unit: string; value: number } {
    const seconds = Math.floor(difference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30.5);
    const years = Math.floor(months / 12);

    if (years > 0) return { unit: 'years', value: years };
    if (months > 0) return { unit: 'months', value: months };
    if (days > 0) return { unit: 'days', value: days };
    if (hours > 0) return { unit: 'hours', value: hours };
    return { unit: 'minutes', value: minutes }; // Assuming minutes as the smallest unit for simplicity
  }

  private getFormattedDate(value: number, unit: string): string {
    switch (unit) {
      case 'years': return value > 1 ? `${value} ${this.getTranslation('date-years')}` : this.getTranslation('date-one-year');
      case 'months': return this.getMonthFormat(value);
      case 'days': return this.getDayFormat(value);
      case 'hours': return value <= 1 ? this.getTranslation('date-last-hours') : this.getTranslation('date-today');
      default: return this.getTranslation('date-this-month'); // Fallback for minutes or unexpected values
    }
  }

  private getMonthFormat(months: number): string {
    if (months >= 12) return this.getTranslation('date-this-month');
    if (months == 1) return this.getTranslation('date-last-month');
    return `${months} ${this.getTranslation('date-months')}`;
  }

  private getDayFormat(days: number): string {
    if (days > 14) return this.getTranslation('date-this-month');
    if (days > 7 && days <= 14) return this.getTranslation('date-two-weeks');
    if (days > 2) return this.getTranslation('date-this-week');
    if (days == 2) return this.getTranslation('date-two-days');
    if (days == 1) return this.getTranslation('date-yesterday');
    return this.getTranslation('date-today');
  }

  /**
   * Format Ids of Attestation/Compromise reports
   * 
   * @param id 
   * @returns string
   */
  formatId(id: string) {
    let mod = id
    if (id.length > 30) {
      let suppr = mod.slice(30, mod.length)
      mod = mod.replace(suppr, "...")
    }

    if (document.documentElement.clientWidth <= 1400) {
      if (id.length > 25) {
        let suppr = mod.slice(25, mod.length)
        mod = mod.replace(suppr, "...")
      }
    }
    if (document.documentElement.clientWidth <= 700) {
      if (id.length > 15) {
        let suppr = mod.slice(15, mod.length)
        mod = mod.replace(suppr, "...")
      }
    }
    return mod;
  }
  formatName(model: string) {
    let mod = model[0].toUpperCase() + model.slice(1);
    if (mod.search('\\(') != -1) {
      let suppr = mod.slice(mod.search("\\("), mod.length);
      mod = mod.replace(suppr, "")
    }
    if (mod.length > 18) {
      let suppr = mod.slice(18, mod.length)
      mod = mod.replace(suppr, "...")
    }
    return mod;
  }
  /**
     * Format date for return only weekday day:month:year of this last
     * 
     * @param time 
     * @param datepipe 
     * @returns string
     */
  timestampToDate(time: number | undefined, datepipe: DatePipe, lang: string) {
    if (time && time != 0) {
      let date = new Date(time)
      return datepipe.transform(date, 'E '+ this.translationService.getDateFormat(), undefined, lang)
    } else return ""
  }

  /**
   * Format date for return only day:month:year of this last
   * 
   * @param time 
   * @param datepipe 
   * @returns string
   */
  onlyDate(time: number | undefined, datepipe: DatePipe) {
    if (time && time != 0) {
      let date = new Date(time)
      return datepipe.transform(date, 'dd/MM/yyyy')
    } else return ""
  }

  /**
   * Format date for return only hours:minutes:seconds of this last
   * 
   * @param timestamp 
   * @param datepipe 
   * @returns string
   */
  horaire(timestamp: number, datepipe: DatePipe) {
    let time = new Date(timestamp)
    return datepipe.transform(time, 'HH:mm:ss')
  }

  /**
   * Return model according to his own length and screen width
   * 
   * @param model 
   * @returns string
   */
  formatAPPName(model: string) {
    let mod = model[0].toUpperCase() + model.slice(1);
    if (mod.search('\\(') != -1) {
      let suppr = mod.slice(mod.search("\\("), mod.length);
      mod = mod.replace(suppr, "")
    }
    if (mod.length > 20) {
      let suppr = mod.slice(20, mod.length)
      mod = mod.replace(suppr, "...")
    }
    if (mod.length > 10 && document.documentElement.clientWidth <= 500) {
      let suppr = mod.slice(10, mod.length)
      mod = mod.replace(suppr, "...")

    }
    return mod;
  }

  /**
   * Return model according to his own length and screen width
   * 
   * @param model 
   * @returns string
   */
  formatVersionCheckBox(model: string) {
    let mod = model
    if (model.length > 15) {
      let suppr = mod.slice(15, mod.length)
      mod = mod.replace(suppr, "...")
    }
    if (document.documentElement.clientWidth <= 700) {
      if (model.length > 10) {
        let suppr = mod.slice(10, mod.length)
        mod = mod.replace(suppr, "...")
      }
    }
    return mod;
  }

  /**
   * 
   * Reduce chaine by n characters and add "..." at the end
   * 
   * @param chaine 
   * @param n 
   * @returns string
   */
  formatN(chaine: string | undefined, n: number) {
    let format = chaine
    if (format) {
      if (format.length > n) {
        let suppr = format.slice(n, format.length)
        format = format.replace(suppr, '...')
      }
    }
    return format
  }

  public random_int?: number = this.randomXY(1, 3)

  randomXY(x: number, y: number) {
    let min = Math.ceil(x);
    let max = Math.floor(y);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /**
   * 
   * @returns random welcoming sentence
   */
  welcomeUser(name?: string): string {
    return this.getTranslation('hello-' + this.random_int) + ' ' + name;
  }

}
